import { Component, OnInit, OnDestroy, signal, WritableSignal, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { CookieService } from 'app/services/utilities/cookie.service';
import { environment } from 'environments/environment';
import { ThemeService } from '@app/services/utilities/theme.service';

@Component({
    selector: 'app-payment-status',
    templateUrl: './payment-status.component.html',
    styleUrls: ['./payment-status.component.scss'],
    standalone: false
})
export class PaymentStatusComponent implements OnInit, OnDestroy {
    private route = inject(ActivatedRoute);
    private cookie = inject(CookieService);
    themeService = inject(ThemeService);

    isLoading: WritableSignal<boolean> = signal(true);
    successful: boolean;
    private subscription: Subscription;

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            if (params['success'] === 'true' || params['success'] === 'false') {
                this.successful = params['success'] === 'true';
                if (this.successful && environment.STAGE === 'prod') {
                    this.goToWebsite();
                }
                if (this.successful) {
                    this.cookie.delete('registerState');
                }
                this.isLoading.set(false);
            }
        });
    }

    goToWebsite() {
        window.location.href = 'https://www.co-assist.fr/merci-commande';
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
